export const redirectAfterCustomerAuth = (navigate, options = {}) => {
  const { isNewCustomer = false } = options;

  if (isNewCustomer) {
    navigate("/cabinet/profile");
    return;
  }

  const isFirstLogin =
    localStorage.getItem("redirectAfterFirstLogin") === "true";

  if (isFirstLogin) {
    localStorage.removeItem("redirectAfterFirstLogin");
    navigate("/cabinet/addresses");
    return;
  }

  const lastPath = localStorage.getItem("lastVisitedPath") || "/";
  navigate(lastPath);
  localStorage.removeItem("lastVisitedPath");
};
